import { useState } from 'react';
import { List, ListItemText, ListItemIcon, ListItemButton, Typography, Divider } from '@mui/material';
import { IconSettings, IconLogout, IconIdBadge2, IconBooks, IconMail, IconContract } from '@tabler/icons-react';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { anchorRef } from 'material-ui-popup-state';
import { logout } from 'store/slice/SliceAuth';
import { useCommon } from 'hooks/hooksCommon';
import { selectIsMobile } from 'store/slice/SliceSidebar';

const ProfileListAdmin = () => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const isMobile = useSelector(selectIsMobile);
    const {navigate} = useCommon();

    const [selectedIndex, setSelectedIndex] = useState(-1);
    // const [open, setOpen] = useState(false);

    const dispatch = useDispatch()
    // const authStatus = useSelector((state) => state.auth)

    const handleLogout = (e) => {
        if (window.AppBridge) {
            window.AppBridge.postMessage(JSON.stringify({ action: 'logout' }));
        }

        // TODO: 한곳으로 옮기기
        dispatch(logout({})).unwrap()
            .then((data) => {
                // console.log(data)
                navigate('/login');
            })
            .catch((err) => {
                console.log(err)
            });
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        // setOpen(false);
    };
    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            window.location.href = route; // 페이지 이동을 위해 window.location.href 사용
        }
    };

    return (
        <List
            component="nav"
            sx={{
                width: '100%',
                maxWidth: 350,
                minWidth: 300,
                backgroundColor: theme.palette.background.paper,
                borderRadius: '10px',
                [theme.breakpoints.down('md')]: {
                    minWidth: '100%'
                },
                '& .MuiListItemButton-root': {
                    mt: 0.5
                }
            }}
        >
            {/* <ListItemButton
                sx={{
                    borderRadius: `${customization.borderRadius}px`
                }}
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0, '/home/contract-board')}
            >
                <ListItemIcon>
                    <IconContract stroke={1.5} size="1.3rem" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">계약 연장 및 해지 신청</Typography>} />
            </ListItemButton>
            <ListItemButton
                sx={{
                    borderRadius: `${customization.borderRadius}px`
                }}
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0, '/home/qna')}
            >
                <ListItemIcon>
                    <IconMail stroke={1.5} size="1.3rem" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">문의사항</Typography>} />
            </ListItemButton>
            <ListItemButton
                sx={{
                    borderRadius: `${customization.borderRadius}px`
                }}
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0, '/home/board')}
            >
                <ListItemIcon>
                    <IconBooks stroke={1.5} size="1.3rem" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">사내게시판</Typography>} />
            </ListItemButton>
            <Divider />
            <ListItemButton
                sx={{
                    borderRadius: `${customization.borderRadius}px`
                }}
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0, '/home/myinfo')}
            >
                <ListItemIcon>
                    <IconIdBadge2 stroke={1.5} size="1.3rem" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">계정 정보</Typography>} />
            </ListItemButton> */}
            <ListItemButton
                sx={{
                    borderRadius: `${customization.borderRadius}px`
                }}
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0, '/home/password-reset')}
            >
                <ListItemIcon>
                    <IconSettings stroke={1.5} size="1.3rem" />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">비밀번호 변경</Typography>} />
            </ListItemButton>
            {/* {!isMobile && ( */}
                <>
                    <Divider />
                    <ListItemButton
                        sx={{
                            borderRadius: `${customization.borderRadius}px`
                        }}
                        selected={selectedIndex === 4}
                        onClick={handleLogout}
                    >
                        <ListItemIcon>
                            <IconLogout stroke={1.5} size="1.3rem" />
                        </ListItemIcon>
                        <ListItemText primary={<Typography variant="body2">로그아웃</Typography>} />
                    </ListItemButton>
                </>
            {/* )} */}
        </List>
    );
};

export default ProfileListAdmin;
